// ============================================
// MIPERFIL.JS — Modal de edición de perfil + cambiar contraseña
// ============================================

import React, { useState } from 'react';
import { API_BASE } from '../config/api';

const PP = "'Poppins', sans-serif";
const colores = { principal: '#5c9adb', oscuro: '#2f5f9e', gris: '#4e5357', grisClaro: '#5e666e', rojo: '#e05c5c', fondo: '#f3f4f4', verde: '#1D9E75' };

const coloresAvatar = ['#5c9adb', '#2f5f9e', '#5cd4b0', '#f4a261', '#e07bbd', '#a78bfa', '#34d399', '#e05c5c', '#a8d96a', '#8fb8e8'];

const inputStyle = {
  width: '100%', padding: '10px 12px', border: '1px solid #d0d0d0', borderRadius: '8px',
  fontSize: '13px', background: '#fff', boxSizing: 'border-box', outline: 'none',
  color: '#4e5357', fontFamily: PP,
};
const labelStyle = { fontSize: '12px', color: '#5e666e', display: 'block', marginBottom: '4px', fontFamily: PP };

// ====== PERFIL ======
export function ModalPerfil({ abierto, onCerrar, nombre, correo, telefono, area, rol, onGuardar }) {
  const [form, setForm] = useState({ nombre: nombre || '', telefono: telefono || '', area: area || '' });
  const [colorAvatar, setColorAvatar] = useState(coloresAvatar[0]);
  const [pickColor, setPickColor] = useState(false);
  const [guardado, setGuardado] = useState(false);

  if (!abierto) return null;

  const iniciales = (form.nombre || 'U').split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase();

  const handleGuardar = () => {
    if (onGuardar) onGuardar(form);
    setGuardado(true);
    setTimeout(() => { setGuardado(false); onCerrar(); }, 1500);
  };

  return (
    <>
      <div onClick={onCerrar} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9998 }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: '#fff', borderRadius: '16px', padding: '28px', width: '90%', maxWidth: '420px', zIndex: 9999, boxShadow: '0 8px 30px rgba(0,0,0,0.2)', fontFamily: PP, maxHeight: 'calc(var(--beep-vh) * 90)', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ fontSize: '16px', fontWeight: '700', color: colores.gris }}>Mi perfil</div>
          <div onClick={onCerrar} style={{ width: '28px', height: '28px', borderRadius: '50%', background: colores.fondo, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '13px', color: colores.grisClaro }}>{'✕'}</div>
        </div>

        {/* Avatar */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div onClick={() => setPickColor(!pickColor)} style={{ width: '72px', height: '72px', borderRadius: '50%', background: colorAvatar, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: 'pointer', border: '3px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
            <span style={{ fontSize: '26px', fontWeight: '700', color: '#fff' }}>{iniciales}</span>
          </div>
          <div style={{ fontSize: '11px', color: colores.grisClaro, marginTop: '6px' }}>Toca para cambiar color</div>
          {pickColor && (
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginTop: '10px', flexWrap: 'wrap' }}>
              {coloresAvatar.map(c => (
                <div key={c} onClick={() => { setColorAvatar(c); setPickColor(false); }} style={{ width: '28px', height: '28px', borderRadius: '50%', background: c, cursor: 'pointer', border: colorAvatar === c ? '2px solid #333' : '2px solid transparent' }} />
              ))}
            </div>
          )}
        </div>

        {/* Campos */}
        <div style={{ marginBottom: '12px' }}>
          <label style={labelStyle}>Nombre completo</label>
          <input value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} style={inputStyle} />
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={labelStyle}>Correo (solo lectura)</label>
          <input value={correo || ''} readOnly style={{ ...inputStyle, background: '#f3f4f4', color: colores.grisClaro }} />
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={labelStyle}>Teléfono</label>
          <input value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} style={inputStyle} />
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={labelStyle}>Área</label>
          <input value={form.area} onChange={e => setForm({ ...form, area: e.target.value })} style={inputStyle} />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Rol</label>
          <input value={rol || ''} readOnly style={{ ...inputStyle, background: '#f3f4f4', color: colores.grisClaro }} />
        </div>

        {guardado && (
          <div style={{ padding: '10px', background: '#e8faf5', borderRadius: '8px', fontSize: '13px', color: colores.verde, textAlign: 'center', marginBottom: '12px' }}>Cambios guardados</div>
        )}

        <button onClick={handleGuardar} style={{ width: '100%', padding: '12px', background: colores.oscuro, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', fontFamily: PP }}>Guardar cambios</button>
      </div>
    </>
  );
}

// ====== CAMBIAR CONTRASEÑA ======
const API = API_BASE;   // direccion del backend: config/api.js (fuente unica)

export function ModalPassword({ abierto, onCerrar }) {
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [msg, setMsg] = useState('');
  const [msgTipo, setMsgTipo] = useState('');
  const [guardando, setGuardando] = useState(false);

  if (!abierto) return null;

  const tieneMayuscula = /[A-Z]/.test(nueva);
  const tieneNumero = /[0-9]/.test(nueva);
  const tieneMinLen = nueva.length >= 8;
  const esValida = tieneMayuscula && tieneNumero && tieneMinLen;

  const fuerza = [tieneMinLen, tieneMayuscula, tieneNumero].filter(Boolean).length;
  const fuerzaColor = fuerza === 3 ? colores.verde : fuerza === 2 ? '#f4a261' : colores.rojo;
  const fuerzaLabel = fuerza === 3 ? 'Fuerte' : fuerza === 2 ? 'Media' : 'Débil';

  const handleGuardar = async () => {
    if (!actual) { setMsg('Ingresa tu contraseña actual'); setMsgTipo('error'); return; }
    if (!esValida) { setMsg('La contraseña no cumple los requisitos'); setMsgTipo('error'); return; }
    if (nueva !== confirmar) { setMsg('Las contraseñas no coinciden'); setMsgTipo('error'); return; }
    setGuardando(true);
    setMsg('');
    try {
      const token = localStorage.getItem('beep_token');
      const r = await fetch(`${API}/api/auth/cambiar-password`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ password_actual: actual, password_nueva: nueva }),
      });
      const d = await r.json();
      if (d.ok) {
        setMsg('Contraseña actualizada correctamente');
        setMsgTipo('ok');
        setActual(''); setNueva(''); setConfirmar('');
        setTimeout(() => { setMsg(''); onCerrar(); }, 2000);
      } else {
        setMsg(d.error || 'Error al cambiar contraseña');
        setMsgTipo('error');
      }
    } catch {
      setMsg('Error de red');
      setMsgTipo('error');
    } finally {
      setGuardando(false);
    }
  };

  const req = (cumple, texto) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: cumple ? colores.verde : colores.grisClaro, fontFamily: PP }}>
      <span>{cumple ? '✓' : '○'}</span> {texto}
    </div>
  );

  return (
    <>
      <div onClick={onCerrar} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9998 }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: '#fff', borderRadius: '16px', padding: '28px', width: '90%', maxWidth: '380px', zIndex: 9999, boxShadow: '0 8px 30px rgba(0,0,0,0.2)', fontFamily: PP }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ fontSize: '16px', fontWeight: '700', color: colores.gris }}>Cambiar contraseña</div>
          <div onClick={onCerrar} style={{ width: '28px', height: '28px', borderRadius: '50%', background: colores.fondo, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '13px', color: colores.grisClaro }}>{'✕'}</div>
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={labelStyle}>Contraseña actual</label>
          <input type="password" value={actual} onChange={e => setActual(e.target.value)} style={inputStyle} />
        </div>
        <div style={{ marginBottom: '8px' }}>
          <label style={labelStyle}>Nueva contraseña</label>
          <input type="password" value={nueva} onChange={e => setNueva(e.target.value)} style={inputStyle} />
        </div>

        {/* Indicador de fortaleza */}
        {nueva && (
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
              {[1, 2, 3].map(i => (
                <div key={i} style={{ flex: 1, height: '4px', borderRadius: '2px', background: i <= fuerza ? fuerzaColor : '#e0e0e0', transition: 'background 0.2s' }} />
              ))}
            </div>
            <div style={{ fontSize: '11px', color: fuerzaColor, fontWeight: '600', fontFamily: PP }}>{fuerzaLabel}</div>
          </div>
        )}

        {/* Requisitos */}
        <div style={{ marginBottom: '14px', display: 'flex', flexDirection: 'column', gap: '3px' }}>
          {req(tieneMinLen, 'Mínimo 8 caracteres')}
          {req(tieneMayuscula, 'Una letra mayúscula')}
          {req(tieneNumero, 'Un número')}
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Confirmar nueva contraseña</label>
          <input type="password" value={confirmar} onChange={e => setConfirmar(e.target.value)} style={inputStyle} />
          {confirmar && nueva !== confirmar && (
            <div style={{ fontSize: '11px', color: colores.rojo, marginTop: '4px', fontFamily: PP }}>Las contraseñas no coinciden</div>
          )}
        </div>

        {msg && (
          <div style={{ padding: '10px', background: msgTipo === 'ok' ? '#e8faf5' : '#fff0f0', borderRadius: '8px', fontSize: '13px', color: msgTipo === 'ok' ? colores.verde : colores.rojo, textAlign: 'center', marginBottom: '12px' }}>{msg}</div>
        )}

        <button onClick={handleGuardar} disabled={guardando} style={{ width: '100%', padding: '12px', background: colores.oscuro, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '700', cursor: guardando ? 'wait' : 'pointer', fontFamily: PP, opacity: (esValida && !guardando) ? 1 : 0.5 }}>{guardando ? 'Guardando...' : 'Guardar contraseña'}</button>
      </div>
    </>
  );
}
